export enum CardVariants {
  OUTLINED = 'OUTLINED',
  SHADOW = 'SHADOW',
}
